import React from "react";
import style from "../Dialogs.module.css";

const Message = (props) => {
    return (
        <div className={style.messageBox}>
                <img src={props.src} alt="Avatar" />


            <div className={style.messageText}>
                {props.message}
                <div className={style.messageTime}>
                    {props.time}
                </div>
            </div>
        </div>
    )
}

export default Message;





